const ifus = [
    {
      id: 1,
      name: "IFU for Flowmeter",
      file: "/IFU/IFU Flowmeter Rev H (NO CE MARK).pdf",
    },
    {
      id: 2,
      name: "IFU for InGage Regulator",
      file: "/IFU/IFU InGage Regulator Rev G (NO CE MARK).pdf",
    },
    {
      id: 3,
      name: "IFU for Hose Assembly - Canadian Standard",
      file: "/IFU/IFU-Hose Assembly - Canadian Standard Rev B.pdf",
    },
    {
      id: 4,
      name: "IFU for Hose Assembly",
      file: "/IFU/IFU-Hose Assembly Rev A.pdf",
    },
    {
      id: 5,
      name: "IFU for RW Regulator",
      file: "/IFU/IFU RW Regulator Rev G (NO CE MARK).pdf",
    },
    {
      id: 6,
      name: "IFU for Mass Casualty Assembly",
      file: "/IFU/IFU Mass Casualty Assembly Rev H (NO CE MARK).pdf",
    },
    {
      id: 7,
      name: "IFU for Multilatorr",
      file: "/IFU/IFU-Multilatorr (2023-12-29) (Rev. A).docx.pdf",
    },
    {
      id: 8,
      name: "IFU for Regulator - Octafluoropropane (C3F8)",
      file: "/IFU/IFU-Regulator-C3F8 Rev C.pdf",
    },
    {
      id: 9,
      name: "IFU for Regulator - Sulfur Hexafluoride (SF6)",
      file: "/IFU/IFU-Regulator-SF6 Rev C.pdf",
    },
    {
      id: 10,
      name: "IFU for Regulator - Smiths Medical",
      file: "/IFU/IFU-Regulator-Smiths Rev C.pdf",
    },
    {
      id: 11,
      name: "IFU for Regulator - Test Kit",
      file: "/IFU/IFU-Regulator-TestKit Rev B.pdf",
    },
    {
      id: 12,
      name: "IFU for Resident Nipple Adapter",
      file: "/IFU/IFU-Resident-Nipple-Adapter Rev A.pdf",
    },
    {
      id: 13,
      name: "IFU for TOAD",
      file: "/IFU/IFU-TOAD Rev A.pdf",
    },
    {
      id: 14,
      name: "IFU for Transfill Cascade System",
      file: "/IFU/IFU-Transfill Cascade System (2023-12-13) (Rev. A).docx.pdf",
    },
  ];
  
  export default ifus;
  